// vim: set ts=2 sts=2 sw=2 et:

import { liftToAttemptFieldName, liftToStatusFieldName } from "../../logic/entry";
import type { Entry, Lift } from "../../types/dataTypes";
import type { WrpfRecordCategory } from "../handoff/types";
import type { PlatformLiveAttemptSeriesItem, PlatformLiveLiftSeries } from "./platformLiveProtocol";

const LIFTS: ReadonlyArray<Lift> = ["S", "B", "D"];

export type RecordCategoryLookup = (lift: Lift, attemptOneIndexed: number) => WrpfRecordCategory | undefined;

/** Intentos de un movimiento: los tres primeros, y el 4º solo si se pidió o es el intento en curso. */
export const buildAttemptSeries = (
  entry: Entry,
  lift: Lift,
  recordCategoryFor: RecordCategoryLookup,
  currentAttemptOneIndexed?: number,
): Array<PlatformLiveAttemptSeriesItem> => {
  const weights = entry[liftToAttemptFieldName(lift)];
  const statuses = entry[liftToStatusFieldName(lift)];
  const count = currentAttemptOneIndexed === 4 || weights[3] > 0 || statuses[3] !== 0 ? 4 : 3;
  return weights.slice(0, count).map((weightKg, index) => {
    const recordCategory = recordCategoryFor(lift, index + 1);
    return {
      weightKg,
      status: statuses[index] > 0 ? "good" : statuses[index] < 0 ? "noLift" : "pending",
      ...(recordCategory === undefined ? {} : { recordAttempt: true, recordCategory }),
    };
  });
};

/**
 * Intentos de todos los movimientos que compite el Entry (la unión de sus modalidades), en orden S → B → D.
 * Las pantallas live los usan para mostrar los mejores y el total acumulado.
 */
export const buildLiftSeries = (
  entry: Entry,
  currentLift: Lift,
  currentAttemptOneIndexed: number,
  recordCategoryFor: RecordCategoryLookup,
): Array<PlatformLiveLiftSeries> =>
  LIFTS.filter((lift) => lift === currentLift || entry.events.some((event) => event.includes(lift))).map((lift) => ({
    lift,
    attempts: buildAttemptSeries(
      entry,
      lift,
      recordCategoryFor,
      lift === currentLift ? currentAttemptOneIndexed : undefined,
    ),
  }));
